import React, { useContext } from 'react'
import '../index.scss'
import Button from '@Components/Buttons/Button'
import { RIGHTSHOLDER_FORM } from '@Const/forms-constants'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface RightsholderMaintenanceContactViewProps {
    pending: boolean
    setEditable: (editable: boolean) => void
}

const RightsholderMaintenanceContactView = (props: RightsholderMaintenanceContactViewProps) => {
    const { pending, setEditable } = props
    const { rightsholderStore } = useContext(StoresContext)
    const rightsHolderData = rightsholderStore.memberSummary

    const { name, hfaPublisherNumber, ipiNumber, isni } = rightsHolderData

    return (
        <div className="rightsholder-maintenance-contact-tab">
            <div className="buttons-block">
                <Button onClick={() => setEditable(true)} mainColor disabled={pending} type="primary">
                    Edit
                </Button>
            </div>
            <section className="name-section">
                <h5>Member Name </h5>
                <div className="fields-row-container">
                    <div className="field-block">
                        <p className="small title">{RIGHTSHOLDER_FORM.name.label}</p>
                        <p className="value">{name}</p>
                    </div>
                </div>
            </section>
            <section className="identifiers-section">
                <h5>Identifiers</h5>
                <div className="fields-row-container">
                    <div className="field-block">
                        <p className="small title">{RIGHTSHOLDER_FORM.hfaPublisherNumber.label}</p>
                        <p className="value">{hfaPublisherNumber}</p>
                    </div>
                    <div className="field-block">
                        <p className="small title">{RIGHTSHOLDER_FORM.ipiNumber.label}</p>
                        <p className="value">{ipiNumber}</p>
                    </div>
                    <div className="field-block">
                        <p className="small title">{RIGHTSHOLDER_FORM.isni.label}</p>
                        <p className="value">{isni}</p>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default observer(RightsholderMaintenanceContactView)
